import { render, staticRenderFns } from "./MitAdminSettingsPage.vue?vue&type=template&id=e0c8f5fa&scoped=true"
import script from "./MitAdminSettingsPage.vue?vue&type=script&lang=js"
export * from "./MitAdminSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./MitAdminSettingsPage.vue?vue&type=style&index=0&id=e0c8f5fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c8f5fa",
  null
  
)

export default component.exports